var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M7.125 19.516h4.75M14.25 9.061v1.394c0 3.067-2.137 5.576-4.75 5.576m0 0c-2.612 0-4.75-2.509-4.75-5.576V9.061m4.75 6.97v3.485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.5 13.94a2.559 2.559 0 0 1-1.14-.275 2.961 2.961 0 0 1-.959-.775c-.556-.66-.87-1.55-.87-2.478V5.576a4.003 4.003 0 0 1 .223-1.336c.149-.423.367-.808.643-1.132.276-.324.604-.58.965-.755A2.58 2.58 0 0 1 9.5 2.09c1.665 0 2.969 1.53 2.969 3.485v4.836c0 1.945-1.332 3.528-2.969 3.528Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordWhite);
export default __webpack_public_path__ + "static/media/record-white.589615604866f955349f6913cc4928ec.svg";
export { ForwardRef as ReactComponent };